var _style, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgZeitauktionLogoPreownedLuxuryWatches(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "406.5px",
    height: "68px",
    viewBox: "0 0 406.5 68",
    style: {
      enableBackground: "new 0 0 406.5 68"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#1A1A1A;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25.5,33.3H0.6L0,29.1L19.2,5H2L1.3,0.8h23.5L25.4,5L5.8,29.1H25L25.5,33.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M41.6,33.3V0.8h18.9L61.2,5H47v9.7h10.8l0.8,4.2H47v10.2h15.5l0.8,4.2H41.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M79.4,33.3V0.8h5.4v32.6H79.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M127.2,5H116v28.3h-5.5V5h-10.3V0.8h26.1L127.2,5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M156.3,0.8L168.8,33l-5.3,0.8l-3.2-8.6h-12.8l-3.1,8.2h-5.3l12.5-32.6H156.3z M153.8,8.1L149,20.8h9.6 L153.8,8.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M189.4,0.8v20.4c0,2.7,0.7,4.7,2.1,6.1c1.4,1.4,3.2,2.2,5.6,2.2s4.2-0.7,5.6-2.2c1.4-1.5,2.1-3.5,2.1-6.1V0.8 h5.4v20.8c0,2.3-0.5,4.4-1.6,6.3c-1.1,1.9-2.6,3.3-4.6,4.4c-2,1.1-4.3,1.6-6.9,1.6c-2.6,0-4.9-0.5-6.9-1.6c-2-1.1-3.5-2.5-4.6-4.4 c-1.1-1.9-1.6-4-1.6-6.3V0.8H189.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M248.3,33.3L237.6,19l-3.4,3.6v10.7h-5.4V0.8h5.4v14.4L248.8,0l3.9,3.1l-11.4,12l13.6,18.2H248.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M293.7,5h-11.2v28.3h-5.5V5h-10.3V0.8h26.1L293.7,5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M309.3,33.3V0.8h5.4v32.6H309.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M347.3,0c3.1,0,5.9,0.7,8.3,2.2c2.4,1.5,4.2,3.5,5.5,6c1.3,2.6,1.9,5.4,1.9,8.6c0,3.3-0.7,6.2-2,8.8 c-1.3,2.6-3.2,4.6-5.6,6.1c-2.4,1.5-5.1,2.2-8.2,2.3c-3.1,0-5.8-0.7-8.2-2.2c-2.4-1.5-4.2-3.5-5.5-6c-1.3-2.6-1.9-5.4-1.9-8.6 c0-3.3,0.7-6.2,2-8.8c1.3-2.6,3.2-4.6,5.6-6.1S344.3,0.1,347.3,0z M337.2,17.2c0,2.4,0.4,4.5,1.2,6.3c0.8,1.9,2,3.3,3.5,4.4 c1.5,1.1,3.3,1.6,5.2,1.6c1.9,0,3.6-0.5,5.2-1.5c1.5-1,2.8-2.5,3.7-4.4c0.9-1.9,1.3-4.1,1.3-6.7c0-2.4-0.4-4.5-1.2-6.3 c-0.8-1.9-2-3.3-3.5-4.4c-1.5-1.1-3.3-1.6-5.2-1.6c-1.9,0-3.6,0.5-5.2,1.6c-1.6,1.1-2.8,2.5-3.7,4.5 C337.6,12.6,337.2,14.7,337.2,17.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M380,33.3V0.8h5.1l16,22.9V0.8h5.4v32.6h-5.1l-16-23.1v23.1H380z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1.3,67.7H0V53.6h3.6c1.6,0,2.8,0.3,3.7,1s1.4,1.8,1.4,3.2c0,1.5-0.5,2.5-1.5,3.3c-1,0.7-2.3,1.1-3.8,1.1H1.3 V67.7z M3.7,54.7H1.3v6.4h2.2c1.2,0,2.1-0.3,2.9-0.8C7,59.8,7.4,59,7.4,57.9c0-1.1-0.3-2-1-2.4C5.8,55,4.9,54.7,3.7,54.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17,53.6h3.6c1.6,0,2.8,0.3,3.7,1c0.9,0.6,1.4,1.7,1.4,3.1c0,1.8-0.9,3-2.5,3.7l3.6,6.4h-1.5l-3.3-6 c-0.6,0.1-1.1,0.1-1.6,0.1h-2.1v5.9H17V53.6z M20.7,54.7h-2.4v6h2.2c1.2,0,2.1-0.2,2.8-0.7c0.7-0.5,1.1-1.2,1.1-2.3 c0-1.1-0.3-1.9-1-2.3C22.8,55,21.9,54.7,20.7,54.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M34.6,67.7V53.6h7.5l0.1,0.9h-6.3V60h5L41,61h-5.1v5.7h6.6l0.1,1H34.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M54.6,62.6h-5.1l-0.2-1h5.1L54.6,62.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M68.3,53.3c1.2,0,2.4,0.3,3.3,0.9c1,0.6,1.8,1.5,2.3,2.6c0.6,1.1,0.8,2.4,0.8,3.8s-0.3,2.7-0.8,3.8 c-0.6,1.1-1.4,2-2.4,2.7c-1,0.6-2.1,1-3.4,1c-1.2,0-2.3-0.3-3.3-0.9c-1-0.6-1.8-1.5-2.3-2.6c-0.6-1.1-0.8-2.4-0.8-3.8 c0-1.4,0.3-2.7,0.8-3.8c0.6-1.1,1.4-2,2.4-2.7C66,53.7,67.1,53.3,68.3,53.3z M63.1,60.7c0,1.2,0.2,2.2,0.7,3.2 c0.4,0.9,1,1.7,1.8,2.2c0.8,0.5,1.6,0.8,2.6,0.8c1,0,1.9-0.3,2.7-0.8c0.8-0.5,1.4-1.3,1.9-2.2c0.4-1,0.7-2,0.7-3.2 c0-1.2-0.2-2.2-0.7-3.2c-0.4-0.9-1-1.7-1.8-2.2c-0.8-0.5-1.6-0.8-2.6-0.8c-1,0-1.9,0.3-2.7,0.8c-0.8,0.5-1.4,1.3-1.9,2.2 C63.3,58.5,63.1,59.5,63.1,60.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M98.2,53.6l-3.7,14.1h-1.3l-3.3-12l-3,12h-1.3l-3.9-14l1.3-0.2l3.3,12.4l3.1-12.3h1.2l3.3,12.3l3.1-12.3H98.2z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M105.9,67.7V53.6h0.8l7.4,10.2l0.7,1.2V53.6h1.3v14.1h-0.8l-7.8-11l-0.3-0.6v11.6H105.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M125.7,67.7V53.6h7.5l0.1,0.9H127V60h5l0.1,0.9H127v5.7h6.6l0.1,1H125.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M146.4,67.7h-4.6V53.6h4.8c2,0,3.6,0.6,4.6,1.9s1.5,3,1.5,5c0,1.3-0.2,2.5-0.7,3.6c-0.5,1.1-1.2,1.9-2.1,2.6 C148.8,67.4,147.7,67.7,146.4,67.7z M146.6,54.7H143v11.9h3.4c1,0,1.8-0.2,2.6-0.7c0.7-0.5,1.3-1.2,1.7-2.1c0.4-0.9,0.6-2,0.6-3.2 c0-1.8-0.4-3.2-1.2-4.3C149.3,55.3,148.1,54.7,146.6,54.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M179.7,67.7h-8.1V53.6h1.3v13.1h6.7L179.7,67.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M188.5,53.6v9c0,0.8,0.2,1.5,0.5,2.2c0.3,0.6,0.8,1.2,1.4,1.5s1.3,0.6,2.1,0.6c0.8,0,1.5-0.2,2.1-0.6 c0.6-0.4,1-0.9,1.4-1.5c0.3-0.7,0.5-1.4,0.5-2.2v-9h1.3v9.1c0,1-0.2,1.9-0.6,2.7c-0.4,0.8-1,1.4-1.8,1.9c-0.8,0.4-1.7,0.7-2.8,0.7 c-1,0-1.9-0.2-2.7-0.7c-0.8-0.4-1.4-1.1-1.8-1.9c-0.4-0.8-0.6-1.7-0.6-2.7v-9.1H188.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M205.2,67.7l5.1-7.1l-4.6-6.7l1.1-0.5l4.5,6.6l4-6.3h1.4l-4.7,7.2l4.4,6.9H215l-4-6.2l-4.4,6.2H205.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M225.5,53.6v9c0,0.8,0.2,1.5,0.5,2.2c0.3,0.6,0.8,1.2,1.4,1.5c0.6,0.4,1.3,0.6,2.1,0.6c0.8,0,1.5-0.2,2.1-0.6 c0.6-0.4,1-0.9,1.4-1.5c0.3-0.7,0.5-1.4,0.5-2.2v-9h1.3v9.1c0,1-0.2,1.9-0.6,2.7c-0.4,0.8-1,1.4-1.8,1.9c-0.8,0.4-1.7,0.7-2.8,0.7 c-1,0-1.9-0.2-2.7-0.7c-0.8-0.4-1.4-1.1-1.8-1.9c-0.4-0.8-0.6-1.7-0.6-2.7v-9.1H225.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M244,53.6h3.6c1.6,0,2.8,0.3,3.7,1c0.9,0.6,1.4,1.7,1.4,3.1c0,1.8-0.9,3-2.5,3.7l3.6,6.4h-1.5l-3.3-6 c-0.6,0.1-1.1,0.1-1.6,0.1h-2.1v5.9H244V53.6z M247.7,54.7h-2.4v6h2.2c1.2,0,2.1-0.2,2.8-0.7c0.7-0.5,1.1-1.2,1.1-2.3 c0-1.1-0.3-1.9-1-2.3C249.8,55,248.9,54.7,247.7,54.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M264.5,67.7l0-5.7l-4.7-8l1.1-0.6l4.2,7.4l4.2-7.1h1.4l-4.9,8.2l0,5.9H264.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M303.8,53.6l-3.7,14.1h-1.3l-3.3-12l-3,12h-1.3l-3.9-14l1.3-0.2l3.3,12.4l3.1-12.3h1.2l3.3,12.3l3.1-12.3 H303.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M316.3,53.6l5.4,14l-1.3,0.2l-1.7-4.3h-6.2l-1.6,4.2h-1.2l5.1-14.1H316.3z M315.6,55.3l-2.7,7.2h5.4 L315.6,55.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M338.7,54.7h-4.9v13.1h-1.3V54.7h-4.9v-1h10.9L338.7,54.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M355.5,54.1l-0.4,1c-0.5-0.2-1-0.4-1.4-0.5s-0.9-0.1-1.6-0.1c-1,0-1.9,0.3-2.7,0.8c-0.8,0.5-1.4,1.3-1.9,2.2 c-0.5,1-0.7,2-0.7,3.2c0,1.1,0.2,2.2,0.6,3.1c0.4,0.9,1,1.7,1.8,2.2c0.8,0.5,1.7,0.8,2.7,0.8c0.7,0,1.3-0.1,1.7-0.2 s0.9-0.3,1.4-0.5l0.5,1c-0.4,0.2-0.9,0.4-1.6,0.5c-0.7,0.2-1.3,0.2-1.9,0.2c-1.4,0-2.6-0.3-3.5-1c-1-0.7-1.7-1.5-2.2-2.6 c-0.5-1.1-0.7-2.3-0.7-3.6c0-1.4,0.3-2.6,0.8-3.8c0.5-1.1,1.3-2,2.3-2.7c1-0.7,2.2-1,3.5-1c0.5,0,1.1,0.1,1.8,0.2 C354.6,53.7,355.1,53.9,355.5,54.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M371.8,67.7v-6.6h-7v6.6h-1.3V53.6l1.3-0.1v6.5h7v-6.4h1.3v14.1H371.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M382.7,67.7V53.6h7.5l0.1,0.9h-6.3V60h5L389,61h-5.1v5.7h6.6l0.1,1H382.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M397.9,67.1l0.3-1c0.4,0.2,1,0.4,1.6,0.6c0.6,0.2,1.2,0.2,1.9,0.2c1.2,0,2.1-0.2,2.7-0.7c0.6-0.5,1-1.1,1-1.8 c0-0.5-0.1-1-0.4-1.4c-0.3-0.4-0.7-0.7-1.2-1c-0.5-0.3-1.3-0.7-2.2-1.1c-2.5-1.1-3.8-2.5-3.8-4.2c0-0.6,0.2-1.2,0.5-1.7 c0.4-0.5,0.9-0.9,1.5-1.2c0.7-0.3,1.4-0.5,2.3-0.5c0.6,0,1.3,0.1,1.9,0.2c0.6,0.2,1.1,0.3,1.6,0.6l-0.5,1c-0.5-0.2-1-0.4-1.4-0.5 c-0.4-0.1-1-0.2-1.6-0.2c-1,0-1.8,0.2-2.4,0.6c-0.6,0.4-0.9,1-0.9,1.7c0,0.5,0.1,1,0.4,1.3c0.3,0.4,0.7,0.7,1.2,1 c0.5,0.3,1.3,0.7,2.3,1.2c0.9,0.4,1.7,0.8,2.2,1.2c0.5,0.4,0.9,0.8,1.2,1.3c0.3,0.5,0.4,1,0.4,1.7c0,0.7-0.2,1.3-0.6,1.9 c-0.4,0.5-1,1-1.7,1.3c-0.7,0.3-1.6,0.5-2.6,0.5c-0.6,0-1.3-0.1-2-0.2S398.3,67.4,397.9,67.1z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZeitauktionLogoPreownedLuxuryWatches);
export default __webpack_public_path__ + "static/media/zeitauktion-logo_preowned-luxury-watches.b893dac31cae37997ba7209465d9e765.svg";
export { ForwardRef as ReactComponent };